<!-- 使用场景 - 动态计算table高度 -->
<template>
  <div class="dynamic">
    <header ref="headerRef" class="header">
      <slot name="header" />
    </header>
    <article ref="articleRef" class="article">
      <slot name="content" />
    </article>
  </div>
</template>
<script lang="ts" setup>
import { ref, onMounted, onUnmounted, nextTick } from "vue";

const headerRef = ref();
const articleRef = ref();

onMounted(() => {
  // 监听窗口大小变化
  window.addEventListener("resize", handleHeight);
  handleHeight();
});

onUnmounted(() => {
  window.removeEventListener("resize", handleHeight);
});

const handleHeight = () => {
  nextTick(() => {
    const headerHeight = headerRef.value.offsetHeight;
    articleRef.value.style.height = `calc(100% - ${headerHeight}px)`;
  });
};
</script>
<style lang="scss" scoped>
.dynamic {
  width: 100%;
  height: 100%;
}
.header {
  width: 100%;
}
.article {
  width: 100%;
}
</style>
